import type { SiteSettingsNavbar } from '@/cms/pages'

type AbTestNavbar = Extract<SiteSettingsNavbar, { _type: 'website.navbar.ab.test' }>

export const selectNavbarVariation = (navbar: AbTestNavbar, treatment: string | undefined) =>
  navbar.variations.find((v) => v.name === treatment)
